export default import.meta.ROLLDOWN_FILE_URL_UKF5w6cUhDaBnvNg9A8J7w